import React, {useEffect, useRef} from 'react';
import classNames from 'classnames';
import {useDispatch} from 'react-redux';

import {editCollegeCourse, scrolledToCollegeCourse} from 'shared/portfolio/actions/college-courses';
import {CollegeCourse as CollegeCourseType} from './college-courses/college-course-form-wrapper';

import Grade from './grade';

interface Props {
  course: CollegeCourseType;
  hover?: boolean;
}

const CollegeCourse = ({course, hover = false}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (course.scrollTo) {
      setTimeout(() => {
        ref.current?.scrollIntoView({behavior: 'smooth'});
        dispatch(scrolledToCollegeCourse(course._id));
      }, 550);
    }
  }, [dispatch, course._id, course.scrollTo]);

  return (
    <div className={classNames('college-course', {'college-course-hover': hover})} ref={ref}>
      <section onClick={() => dispatch(editCollegeCourse(course))}>
        <h4 className="college-course-name">{course.name}</h4>
        <p className="college-course-institution">{course.institution.name}</p>
        <div className="college-course-detail">
          <span>{`${course.courseCode} | ${course.creditHours} Credit Hours`}</span>
        </div>
        <div className="prefix-flex">
          <Grade hover={hover} grade={course.grade} />
        </div>
      </section>
    </div>
  );
};

export default CollegeCourse;
